import Routes from './routing';

export * from './routing';
export default Routes;
